import { SafeImage } from "@/app/components/SafeImage";

interface ImageProps {
  src?: string | null;
  alt?: string | null;
  fill?: boolean;
  className?: string;
  aspectRatio?: string;
}

export function ImageComponent({ src, alt, fill = false, className, aspectRatio = "4/3" }: ImageProps) {
  return (
    <SafeImage
      src={src}
      alt={alt}
      fill={fill}
      className={className}
      objectFit="cover"
      fallback={
        <div className={`aspect-[${aspectRatio}] relative bg-gray-50`}>
          <div className="flex items-center justify-center h-full">
            <p className="text-gray-500">Resim yok</p>
          </div>
        </div>
      }
    />
  );
}
